import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/users/imageNotFound.png';
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 1,
  alt: "preview image",
  class: "img-fluid",
  src: _imports_0
};
const _hoisted_4 = {
  key: 1,
  class: "fullscreen-container"
};
const _hoisted_5 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_modal = _resolveComponent("b-modal");
  return _openBlock(), _createBlock(_component_b_modal, {
    modelValue: $data.localModalVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.localModalVisible = $event),
    "body-class": "p-0 text-center",
    centered: "",
    "hide-footer": "",
    "hide-header": "",
    "hide-header-close": ""
  }, {
    default: _withCtx(() => [$options.isImage($props.attachment) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [$props.attachment ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: $props.attachment,
      alt: "preview image",
      class: "img-fluid"
    }, null, 8, _hoisted_2)) : (_openBlock(), _createElementBlock("img", _hoisted_3))])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("iframe", {
      src: $props.attachment
    }, null, 8, _hoisted_5)]))]),
    _: 1
  }, 8, ["modelValue"]);
}